import {Component, ErrorInfo, HTMLAttributes, ReactNode} from 'react';
import {requestContext} from '../common/requestContext';
import {DisplayAd} from '../design-system/organisms/DisplayAd/DisplayAd';
import {DisplayAdType} from '../design-system/organisms/DisplayAd/DisplayAdType.enum';
import {SerializedPagewebError} from './SerializedPagewebError.interface';

interface Props extends HTMLAttributes<HTMLDivElement> {
  type: DisplayAdType;
  children: ReactNode;
}

interface State {
  shouldHandleError: boolean;
  serializedPagewebError?: SerializedPagewebError;
}

/**
 * 아주 가끔 adfit library 를 못읽어오는 경우도 있어 전면에러 예방할 겸 DaErrorBoundary 를 구현했습니다
 */
export class DaErrorBoundary extends Component<Props, State> {
  public state: State = {
    shouldHandleError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return {
      shouldHandleError: true,
    };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // TODO: 적절한 로깅 처리
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    const {children, type, ...props} = this.props;
    if (!this.state.shouldHandleError) {
      return children;
    }
    return (
      <DisplayAd
        isWebView={requestContext.requestInfo.display.isWebView}
        type={type}
        showFallback={true}
        {...props}
      />
    );
  }
}
